export default function reverseDateRepresentation(date: string) {
   if (date) {
      const parts = date.split('-')
      return `${parts[2]}-${parts[1]}-${parts[0]}`
   }
   return null
}
